module.exports = function(){ /* empty */ };


//////////////////
// WEBPACK FOOTER
// /app/~/core-js/library/modules/_add-to-unscopables.js
// module id = ../../../../core-js/library/modules/_add-to-unscopables.js
// module chunks = 7